import React, { useState, useEffect, useContext, useRef } from "react";
import { CurrentUserContext } from '../../../context/CurrentUserContext.js';
import { useParams, useNavigate } from "react-router-dom";
import { courseRegistry } from "../../../courses/courseRegistry.js";
import { videoBaseUrl } from "../LevelContentData";
import { videoTitle } from "../../../utils/titles.js";
import { slugify, slugToText } from "../../../utils/slugify";
import { slugAlias } from "../../../utils/slugAlias.js";
import "./VideosHome.css"; 
//import { TreeNode } from "../../MindMap/MindMap.jsx";
import { Link } from "react-router-dom" ;
import VideoPlayer from "../../VideoPlayer/VideoPlayer";
import {countryToLang } from "../../../utils/languageMap.js";
//import { getAccessibleLevels } from "../../../utils/accessibleLevels.js";
import { useTranslation } from "../../../utils/hooks/translateHook.js";  
import { useLevelContentData } from "../../../utils/hooks/translateLevelContentDataHook.js";
import { transformLevelContent } from "../../../utils/transformLevelContent.js";
//import ProfilePic from "../../../images/pp_default.png";
import fundamentals from "../config.js";
import { hasAccess } from "../../../utils/permissions.js";
import { getCourseProgress } from "../../../utils/API/progressApi.js";


export const API_URL = window.location.hostname === "localhost"
  ? "http://localhost:4000/api"
  : process.env.REACT_APP_API_URL //"http://academy-backend-env.eba-qassrxas.eu-north-1.elasticbeanstalk.com/api";

const CLOUDFRONT_DOMAIN = "vixacademy.com/videos"  //"d2ytlht1oeujr4.cloudfront.net";

 //Creates mini ID's global so 1.1.2  or 1.1.4 etc finds the translation
  const extractPrefix = (str) => {  //used by UI - lecture link hls fix as well besides the level check for the users
    const match = str.match(/^(\d+)[.-](\d+)[.-](\d+)/);
    return match ? `${match[1]}.${match[2]}.${match[3]}` : null;
  };

    //Slugify Link and UI BUGFIX >> main  Helper function 
  const buildVideoPrefixMap = (levels = []) => {
    const map = {};

    levels.forEach(level => {
      (level.subjects || []).forEach(subject => {
        (subject.videos || []).forEach(video => {
          const prefix = extractPrefix(video);
          if (prefix) map[prefix] = video;
        });
      });

      (level.videos || []).forEach(group => {
        (group.list || []).forEach(video => {
          const prefix = extractPrefix(video);
          if (prefix) map[prefix] = video;
        });
      });
    });

    return map;
  };

/* console.log("Fetching videos from:", `${API_URL}/videos`);  */
const VideosHome = ({ user, subject }) => {
  const {currentUser , notesUpdated, setNotesUpdated} = useContext(CurrentUserContext);
  const [currentProgress, setCurrentProgress] = useState(null);
 // const [openTreeIndex, setOpenTreeIndex] = useState(null);
 // const [selectedLevel, setSelectedLevel] = useState(null);
  const [openSubjectIndex, setOpenSubjectIndex] = useState(null);
  const [note, setNote] = useState("");
  const [signedVideoUrl, setSignedVideoUrl] = useState(null);
  const saveTimeout = useRef(null);

  const t = useTranslation();

  const translatedData = useLevelContentData (
      fundamentals.levelContentData,
      fundamentals.slug
    )
  
  //const translatedLevelContentData = useLevelContentData();
  const transformedData = transformLevelContent(translatedData)

  const navigate = useNavigate(); 

  const { videoSlug, courseSlug } = useParams();

  const accessibleLevels = transformedData
  .filter(item => hasAccess(user, item.level, courseSlug) && item.level !== 9999)
  .sort((a, b) => a.level - b.level);

 /*  const levelInfo = currentUser?.subscriptionLevel
  ? transformedData.find(item => item.level === currentUser.subscriptionLevel)
  : null; */
  //const levelTitle = levelInfo?.title || 'Unknown';

  const courseConfig = courseRegistry[courseSlug];
  const realSlug = slugAlias[videoSlug] || videoSlug; 
  const realPrefix = realSlug?.split("-").slice(0, 3).join(".");
  //const userLevel = user.subscriptionLevel;
  const userCourse = user?.courses?.find(
    (course) => course.courseSlug === courseSlug && course.status === "active"
  );
  const userLevel = user?.subscriptionLevel === 9999 
    ? 9999
    : Number(userCourse?.level || 0 );

  //const levelData = transformedData.find((level) => level.level === userLevel);
  //const subjects = levelData?.subjects || [];
  const [lang2Letter, setLang2Letter] = useState("en");


  const getLangByCountry = (countryValue) => {
    if (!countryValue) return "en";
    return countryToLang[countryValue.toUpperCase()] || "en";
  };    
  
 

  useEffect(() => {
    if (user?.country) {
      const code = user.country.toUpperCase()
      const defaultLang = getLangByCountry(code);
      console.log("🌎 Country:", user.country, "→ Default lang:", defaultLang);
      setLang2Letter(defaultLang);
    }
  }, [user?.country]);


//the useEffect that provides order for the level of the users
useEffect(() => {
  if (!realSlug || !courseSlug || !userLevel || !transformedData.length) {
    return;
  }

  //const slugText = videoSlug; // dependecy dahil kaldirabiliriz
  const slugPrefix = realSlug.split("-").slice(0, 3).join(".");
  /* console.log("🔍 Target prefix to match:", slugPrefix); */

  let requiredLevel = null;

  // Flatten all videos into a list
  const allVideos = transformedData.flatMap(level =>
    (level.videos || []).flatMap(group =>
      (group.list || []).map(video => ({
        level: level.level,
        title: typeof video === "string" ? video : video.title
      }))
    )
  );

  // Find matching video by prefix
  const matched = allVideos.find(video => {
    const videoPrefix = extractPrefix(video.title);
    return videoPrefix && videoPrefix === slugPrefix;
  });

  if (matched) {
    requiredLevel = matched.level;
    console.log(`✅ Match found ➤ Title: ${matched.title} | Level: ${requiredLevel}`);
  }

  console.log("🎯 Matched video:", matched?.title || "none", "| Required level:", requiredLevel, "| User level:", userLevel);

  if (requiredLevel && userLevel < requiredLevel) {
    console.warn("🚫 Access denied: video beyond user level");
    navigate("/upgrade");
  }
}, [navigate, videoSlug, realSlug, courseSlug, userLevel, transformedData]);

//Completion  Progress useEffect
useEffect(() => {
  if (!courseSlug || !videoSlug) return;

  getCourseProgress(courseSlug)
    .then(({ courseProgress}) => {
         /* console.log("COURSE PROGRESS:", courseProgress);
         console.log("MATCHING SLUGS:", { realSlug, videoSlug }); */
      const thisVideo = courseProgress.progress?.find(
        item => item.lessonSlug === realSlug || item.lessonSlug === videoSlug 
      );
         console.log("THIS VIDEO PROGRESS:", thisVideo);
      setCurrentProgress(thisVideo || null); 
    })
    .catch(() => setCurrentProgress(null));
}, [courseSlug, videoSlug, realSlug]);



  useEffect(() => {
    console.log("running useEffect for video URL setup", realSlug, currentUser);
    if (!realSlug || !currentUser) return;

    const isLocal = window.location.hostname === "localhost";
    const fallbackUrl = `${videoBaseUrl}${realSlug}/master.m3u8`;

    if (isLocal) {
      //console.log("Localhost detected → Using offline video:", fallbackUrl);
      setSignedVideoUrl(fallbackUrl);
      return;
    }
    fetch(`${API_URL}/video-url/${courseSlug}/${realSlug}?_=${Date.now()}`, {  // Only run this fetch if NOT localhost
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      credentials: "include",
    })
      .then((res) => {
          if (res.status === 403) {
            navigate("/upgrade");
            return Promise.reject("Access denied");
          }
          if (!res.ok) {
            return Promise.reject("Request failed");
          }
          return res.json();
        })
      .then((data) => {
        const cloudUrl = `https://${CLOUDFRONT_DOMAIN}/${realSlug}/master.m3u8`;
        const finalUrl = data.signedUrl || cloudUrl;      //data.signedUrl  will be undefined/null if not allowed also starts null then gets the url-good for singular files 
        //console.log("✅ Using signed or fallback cloud URL:", finalUrl);
        setSignedVideoUrl(finalUrl);
      })
      .catch((err) => {
        //console.warn("⚠️ Fetch error → fallback to local video:", fallbackUrl);
        setSignedVideoUrl(fallbackUrl);
      });
  }, [navigate, realSlug, currentUser]);

  /*   const videoUrl = `${API_URL}/video-url/${realSlug}`; */   
  //for showing present notes
  useEffect(() => {
    if (!realSlug || !user) return;

    fetch(`${API_URL}/notes/${courseSlug}/${realSlug}?_=${Date.now()}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("No note found");
        return res.json();
      })
      .then((data) => {
        if (data && data.content) {
          setNote(data.content);
        } else {
          setNote("");
        }
      })
      .catch((err) => {
        console.log("An Error Occured:", err)
      });
  }, [realSlug, courseSlug ,user, notesUpdated]);

  useEffect(() => {
    if (!note || !realSlug || !user) return;
    clearTimeout(saveTimeout.current);

    saveTimeout.current = setTimeout(() => {
      fetch(`${API_URL}/notes/${courseSlug}/${realSlug}?_=${Date.now()}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
        body: JSON.stringify({ content: note })
      }).then(res => {
        if (res.ok) {
          console.log("💾 Auto-saved");
          setNotesUpdated(prev => prev + 1);
        }
      }).catch(console.error);
    }, 25000); 
  }, [note, realSlug, courseSlug, user, setNotesUpdated]);

  const handleSaveNote = () => {
    fetch(`${API_URL}/notes/${courseSlug}/${realSlug}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ content: note })
    })
    .then(res => res.json())
    .then(() => {
      setNotesUpdated(prev => prev +1);  
      alert('Note saved!');
    });
  };

  //first video redirect
  useEffect(() => {
    if (!videoSlug && courseConfig) {
      const firstLevelWithVideos = courseConfig.levelContentData.find(
        level => Array.isArray(level.videos) && level.videos.length > 0
      );
      const firstVideo = firstLevelWithVideos?.videos?.[0]?.list?.[0];

      if (firstVideo) {
        navigate(
          `/course/${courseSlug}/videos/${slugify(firstVideo)}`,
          {replace: true}
        );
      }
    }
  }, [videoSlug, courseSlug, courseConfig, navigate]);

  const handleDownloadNote = () => {
    const element = document.createElement("a");
    const file = new Blob([note], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = `${slugToText(videoSlug)}-note.txt`;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  //left menu and links fix after UI translations
  const englishVideoByPrefix = React.useMemo(() => {
    return buildVideoPrefixMap(courseConfig?.levelContentData || []);
  }, [courseConfig]);

  const translatedVideoByPrefix = React.useMemo(() => {  // notes kisminda kullaniyoruz displayTitle parametresi ile
    return buildVideoPrefixMap(transformedData || []);
  }, [transformedData]);

  const displayTitle =
    translatedVideoByPrefix[realPrefix] ||   slugToText(realSlug);

  //console.log("accesibledata", accessibleLevels)

  
  return (
    <div className="layout">
      <div className="video-page">
        <div className="video-content">
          {/* Sidebar */}
          <aside className="sidebar">
            {/* <div className="user-profile">
              {<img className="profile-pic" src={currentUser.profilePicture || ProfilePic  } /> }
            </div> */}
            <h3>{t('video_courses')}</h3>
            {/*Sidebar Lessons Tree under*/}
            <div className="map-container video-sidebar">
              {accessibleLevels.flatMap(level => level.subjects || []).map((subject, idx) => (
                <details key={idx} className="subject-accordion video"
                  open={openSubjectIndex === idx}
                >
                  <summary className="videoSubject-title"
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenSubjectIndex(openSubjectIndex === idx ? null : idx);
                    }}
                  >
                    {(subject.title).toUpperCase()}
                  </summary>

                  {Array.isArray(subject.videos) && subject.videos.length > 0 && (
                    <ul className="video-list">
                      {subject.videos.map((filename, vidIdx) => {

                        const prefix = extractPrefix(filename);
                        const englishTitle = englishVideoByPrefix[prefix] || filename;
                        const canonicalSlug = slugify(englishTitle);

                        return (
                          <li key={vidIdx}>
                            <Link to={`/course/${courseSlug}/videos/${canonicalSlug}`}>
                              {videoTitle(filename)
                                .replace(/^\d+(\.\d+)*\.\s*/, '')
                                .toUpperCase()}
                            </Link>
                          </li>
                        );

                      })}
                    </ul>
                  )}

                </details>
              ))}
            </div>

          </aside>

          {/* Main Content */}
          <main className="video-main">
            {user && videoSlug && signedVideoUrl && (
              <div className="video-box">
                {/* <h2 className="video-title">{slugToText(videoSlug)}</h2> */}
                <VideoPlayer
                 // key={signedVideoUrl}  //signedVideoUrl
                  videoUrl={signedVideoUrl} // signedVideoUrl
                  country={user?.country}    
                  lang={lang2Letter} 
                  onProgress={({ watchedSeconds, videoDuration }) => {
                    const token = localStorage.getItem("token");

                    fetch(`${API_URL}/progress`, {
                      method: "POST",
                      headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                      },
                      body: JSON.stringify({
                        courseSlug,
                        lessonSlug: realSlug,
                        lessonType: "video",
                        title: videoTitle(displayTitle)
                          .replace(/^(\d+)\s(\d+)\s(\d+)/, "$1.$2.$3"),
                        watchedSeconds,
                        videoDuration
                      })
                    })
                    .then(res => res.json())
                    .then(data => console.log("Video Progress Saved:", data))
                    .catch(err => console.error("Video Progress Error", err));
                  }}      
                />
              </div>
            )}
            
            <div className="video-status-box">
              <p> Status: {currentProgress?.status || "not started"} </p>

              {currentProgress?.watchedPercent > 0 && (
                <p>Watched: {currentProgress.watchedPercent}%</p>
              )}

              {currentProgress?.completedAt && (
                <small> Completed: {new Date(currentProgress.completedAt).toLocaleString()} </small>
              )}

              {currentProgress?.lastVisitedAt && (
                <small> Last visited: {new Date(currentProgress.lastVisitedAt).toLocaleString()} </small>
              )}
            </div>

            <div className="notes-section">
             {/*  <p><strong>Video Name: </strong> {slugToText(videoSlug)}</p> */}
              <p>
                <strong>{t('lessonName')} </strong>
                {videoTitle(displayTitle)
                  .replace(/^(\d+)\s(\d+)\s(\d+)/, '$1.$2.$3')
                  .toUpperCase()}
              </p>
              <div className="note-layout">
                <div className="note-buttons">
                  <button className="save-button" onClick={handleSaveNote}>{t('save')}</button>
                  <button className="download-button" onClick={handleDownloadNote}>{t('download')}</button>
                </div>
                <textarea 
                  className="note-input"
                  placeholder="Write your notes here..."
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default VideosHome;
